<nb-alert status="success" *ngIf="onlineStatus.connOnline" class="alert-style" >
    Internet is back online.
</nb-alert>

<nb-alert status="warning" *ngIf="onlineStatus.connOffline" class="alert-style" >
    Internet is offline.
</nb-alert>
